"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigTranscriptContainer = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var BigTranscriptContainerDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 3rem;\n  left: 2rem;\n  right: 2rem;\n  z-index: 10;\n\n  color: #fff;\n  font-size: 1.4rem;\n"], ["\n  position: absolute;\n  top: 3rem;\n  left: 2rem;\n  right: 2rem;\n  z-index: 10;\n\n  color: #fff;\n  font-size: 1.4rem;\n"
    /**
     * A React component that can be used for wrapping and positioning BigTranscript components.
     *
     * The intended usage is as follows:
     *
     * <BigTranscriptContainer>
     *   <BigTranscript />
     * </BigTranscriptContainer>
     *
     * And then you can use CSS for styling the layout.
     *
     * @public
     */
])));
/**
 * A React component that can be used for wrapping and positioning BigTranscript components.
 *
 * The intended usage is as follows:
 *
 * <BigTranscriptContainer>
 *   <BigTranscript />
 * </BigTranscriptContainer>
 *
 * And then you can use CSS for styling the layout.
 *
 * @public
 */
var BigTranscriptContainer = function (props) {
    return react_1.default.createElement(BigTranscriptContainerDiv, null, props.children);
};
exports.BigTranscriptContainer = BigTranscriptContainer;
var templateObject_1;
//# sourceMappingURL=BigTranscriptContainer.js.map